import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % testimonials.length), 7000);
    return () => clearInterval(t);
  }, []);

  const t = testimonials[i];

  return (
    <section id="testimonials" className="relative bg-[#0a0a0a] py-28 lg:py-40 px-6 lg:px-12 overflow-hidden">
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?w=1800&q=80')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-[#0a0a0a]/85 to-[#0a0a0a]" />

      <div className="relative max-w-4xl mx-auto text-center">
        <p className="text-[#c9a96e] text-[11px] tracking-[0.5em] uppercase mb-6">Kind Words</p>
        <h2 className="font-serif text-white text-5xl md:text-6xl lg:text-7xl leading-[1.05]">
          Whispered
        </h2>
        <h2
          className="font-serif italic text-[#c9a96e] text-5xl md:text-6xl lg:text-7xl leading-[1.05] -mt-1"
          style={{ fontFamily: 'Cormorant Garamond, serif' }}
        >
          Praise
        </h2>

        <div className="mt-16 min-h-[260px] flex flex-col items-center">
          <div
            key={i}
            className="animate-[fadeIn_0.8s_ease-out] text-white/85 font-serif italic text-2xl md:text-3xl lg:text-[34px] leading-[1.5] max-w-3xl"
            style={{ fontFamily: 'Cormorant Garamond, serif' }}
          >
            “{t.quote}”
          </div>
          <div className="w-10 h-px bg-[#c9a96e] my-8" />
          <div className="text-white text-[13px] tracking-[0.25em] uppercase">{t.name}</div>
          <div className="text-white/50 text-[10px] tracking-[0.35em] uppercase mt-2">
            {t.event}
          </div>
        </div>

        <div className="flex justify-center items-center gap-6 mt-12">
          <button
            onClick={() => setI((p) => (p - 1 + testimonials.length) % testimonials.length)}
            className="w-11 h-11 border border-white/15 hover:border-[#c9a96e] hover:text-[#c9a96e] text-white/60 flex items-center justify-center transition-colors"
            aria-label="Previous"
          >
            <ChevronLeft size={16} />
          </button>
          <div className="flex gap-2">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setI(idx)}
                className={`h-px transition-all duration-500 ${
                  idx === i ? 'w-10 bg-[#c9a96e]' : 'w-6 bg-white/20'
                }`}
                aria-label={`Testimonial ${idx + 1}`}
              />
            ))}
          </div>
          <button
            onClick={() => setI((p) => (p + 1) % testimonials.length)}
            className="w-11 h-11 border border-white/15 hover:border-[#c9a96e] hover:text-[#c9a96e] text-white/60 flex items-center justify-center transition-colors"
            aria-label="Next"
          >
            <ChevronRight size={16} />
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
};

export default Testimonials;
